// extracted by mini-css-extract-plugin
export default {"widgetInputForm":"styles_widgetInputForm__+3NBD","formLabel":"styles_formLabel__RjMJk","pointer":"styles_pointer__gWiiz","noPointer":"styles_noPointer__B8gIP"};